import { MappingFeedback } from '../../types/dynamodb';
import { NexusApiService } from '../nexusApiService';

/**
 * Backend-aligned UI client for NexusMappingFeedbackService APIs.
 */
export class NexusMappingFeedbackService {
  constructor(private readonly api: NexusApiService) {}

  async submitFinalFeedback(
    feedback: Omit<MappingFeedback, 'timestamp'>
  ): Promise<void> {
    return this.api.submitFinalFeedback(feedback);
  }

  async submitFeedback(
    mappingId: string,
    data: {
      feedbackProviderId: string;
      label: 'thumbs_up' | 'thumbs_down';
      decision: 'agree' | 'disagree';
      feedback?: string;
    }
  ): Promise<{ message: string; mappingKey: string; feedbackId: string; label: string }> {
    return this.api.submitFeedback(mappingId, data);
  }

  async updateFeedback(
    mappingId: string,
    feedbackId: string,
    data: {
      label?: 'thumbs_up' | 'thumbs_down';
      decision?: 'agree' | 'disagree';
      feedback?: string;
    }
  ): Promise<{ message: string; mappingKey: string; feedbackId: string }> {
    return this.api.updateFeedback(mappingId, feedbackId, data);
  }

  async listFeedbacks(
    mappingId: string,
    params?: { maxResults?: number; nextToken?: string }
  ): Promise<{ mappingId: string; feedbacks: MappingFeedback[]; count: number; nextToken?: string }> {
    return this.api.listFeedbacks(mappingId, params);
  }

  async getUserFeedbackForMappings(
    mappingIds: string[],
    userId: string
  ): Promise<Map<string, { label: string; feedback?: string; feedbackId: string }>> {
    return this.api.getUserFeedbackForMappings(mappingIds, userId);
  }
}

